import React, { Component } from "react";
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  // Tooltip,
  // OverlayTrigger,
} from "react-bootstrap";
import MaterialTable, { MTableAction } from "material-table";
import CustomContentAlert, { navigationButtons } from "../helper";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import { SuperAdminAction } from "../../Actions";
import isEqual from "lodash/isEqual";
import TextField from "@material-ui/core/TextField";
import styled from "styled-components";
import SetPermission from "./SetPermission";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import _ from "lodash";

class AddUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      email: "",
      country_code: "",
      phone: "",
      user_type: "",
      property_id: "",
      validFirstName: true,
      validLastName: true,
      validEmail: true,
      validPhone: true,
      validUserType: true,
      formIsValid: false,
      searchValue: "",
      searchedUser: [],
      userList: [],
      propertyList: [],
      api_response: false,
      api_error_message: "",
      api_success_message: "",
      show_alert: false,
      show_error: false,
      nameError: {
        error: false,
        label: "",
        helperText: "",
        validateInput: false,
      },
      setNameError: {
        error: false,
        label: "",
        helperText: "",
        validateInput: false,
      },
      modelOpenClose: false,
      module_permissions: {},
      userDataToBeEdited: {},
    };
    this.addActionRef = React.createRef();
  }

  componentDidMount = async () => {
    const property_id =
      this.props.location &&
      this.props.location.search &&
      this.props.location.search.split("?")[1]
        ? this.props.location.search.split("?")[1]
        : "";
    this.setState({ loader: true }, async () => {
      await this.props.fetchUsers(property_id);
      await this.props.get_all_properties();
      console.log("this.props.userList:----", this.props.userList);
      this.setState(
        {
          highsecurity: this.props.userList[0]?.high_security,
          userList: this.props.userList,
          propertyList: this.props.getAllProperties,
          loader: false,
          api_response: this.props.api_response,
          property_id: property_id,
          modelOpenClose: this.props.modelOpenClose,
          userTypes: this.props.allUserTypes,
        },
        () => {
          const selectedPropertyObj =
            this.state.propertyList &&
            this.state.propertyList.length &&
            this.state.propertyList.filter(
              (item) => item.id === this.state.property_id
            );
          const selectedPropertyName =
            selectedPropertyObj &&
            selectedPropertyObj.length &&
            selectedPropertyObj &&
            selectedPropertyObj[0].site_name;
          const selectedDomainName =
            selectedPropertyObj &&
            selectedPropertyObj.length &&
            selectedPropertyObj &&
            selectedPropertyObj[0].domain;
          this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
        }
      );
    });
    await this.props.fetchAllUserTypes();
  };

  componentDidUpdate = (prevProps) => {
    this.props.userList.forEach(function (item) {
      delete item.password;
    });
    if (!isEqual(prevProps.userList, this.props.userList)) {
      this.setState({ userList: this.props.userList });
    }
    if (prevProps.modelOpenClose !== this.props.modelOpenClose) {
      this.setState({ modelOpenClose: this.props.modelOpenClose });
    }
  };

  changeProperty = (event) => {
    this.setState({ selectedProperty: event.target.value });
  };

  changePermission = (event) => {
    this.setState({ selectedPermission: event.target.value });
  };

  handleSubmit = async (form_data) => {
    await this.props.addUser(form_data);
    if (this.props.api_response) {
      this.setState(
        {
          show_alert: true,
          api_success_message: this.props.api_success_message,
        },
        () => {
          this.hideAlert();
        }
      );
    } else {
      this.setState(
        {
          show_error: true,
          api_error_message: this.props.api_error_message,
        },
        () => {
          setTimeout(() => {
            this.setState({ show_error: false });
          }, 4000);
        }
      );
    }
  };

  hideAlert = () => {
    setTimeout(() => {
      this.setState({
        show_alert: false,
      });
    }, 4000);
  };

  handleUserEdit = async (editData) => {
    await this.props.editUser({
      ...editData,
      old_data: this.state.userList.find((x) => x.id === editData.id),
    });
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
      });
      this.hideAlert();
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  handleUserDelete = async (userId) => {
    await this.props.deleteUser(userId, this.state.property_id);
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
      });
      this.hideAlert();
    } else {
      this.setState({
        show_error: true,
        api_error_message: this.props.api_error_message,
      });
      setTimeout(() => {
        this.setState({ show_error: false });
      }, 4000);
    }
  };

  PhoneValidation = (rowData) => {
    if (Object.keys(rowData).length !== 0 && "phone" in rowData) {
      if (rowData && rowData.phone === "") {
        return "Phone number is required!";
      } else if (
        (rowData && rowData.phone && rowData.phone.length >= 11) ||
        (rowData && rowData.phone && rowData.phone.length < 10)
      ) {
        return "Please  enter valid Phone Number";
      } else if (!/^\d+$/.test(rowData.phone)) {
        return "Please  enter valid Phone Number";
      }
    }
    return "";
  };

  AddRow = () => {
    this.setState({
      modelOpenClose: true,
      users_permission: [],
    });
  };

  EditRow = (rowData) => {
    this.setState({
      modelOpenClose: true,
      userDataToBeEdited: rowData,
    });
  };

  DeleteRow = async (rowData) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this entry?"
    );
    if (confirmation) {
      this.handleUserDelete(rowData.id);
    }
  };

  handleClose = () => {
    this.setState({
      modelOpenClose: false,
      userDataToBeEdited: {},
    });
  };

  handleUserPermission = (userPermissions, userData, isEdit) => {
    const module_permissions = [];
    !_.isEmpty(userPermissions) &&
      userPermissions.map((ele) => {
        module_permissions.push({
          permission_module_name: ele.label,
          is_active: ele.is_active,
          permission_module_id: ele.permission_module_id,
        });
        return ele;
      });

    this.setState({
      module_permissions: module_permissions,
    });
    const new_form_data = {
      property_id: this.state.property_id,
      first_name: userData.Firstname,
      last_name: userData.Lastname,
      username: userData.Username,
      country_code: userData.country_code,
      phone: userData.Phone,
      user_type: userData.userType,
      user_sub_type: userData.userSubType,
      email: userData.Email,
      password: userData.password,
    };
    if (!isEdit) {
      this.handleSubmit(new_form_data);
    } else {
      new_form_data.id = userData.id;
      this.handleUserEdit(new_form_data);
    }
    this.handleClose();
  };

  render() {
    const {
      loader,
      userList,
      api_success_message,
      api_error_message,
      show_alert,
      show_error,
      modelOpenClose,
      highsecurity,
    } = this.state;
    this.columns = [
      {
        title: "Email",
        field: "email",
        type: "email",
        //  readonly: true,
        validate: (rowData) => {
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return rowData.email === ""
            ? "Email is required!"
            : rowData.email && !regex.test(rowData.email)
            ? "Please enter valid email."
            : "";
        },
      },
      {
        title: "First Name",
        field: "first_name",
        validate: (rowData) =>
          rowData.first_name === "" ? "First name is required!" : "",
      },
      {
        title: "Last Name",
        field: "last_name",
        validate: (rowData) =>
          rowData.last_name === "" ? "Last name is required!" : "",
      },
      {
        title: "Username",
        field: "username",
        validate: (rowData) =>
          rowData.last_name === "" ? "User name is required!" : "",
      },
      {
        title: "Country Code",
        field: "country_code",
        validate: (rowData) =>
          rowData.country_code.length > 4
            ? "Please enter proper country code"
            : "",
      },
      {
        title: "Phone",
        field: "phone",
        validate: (rowData) => this.PhoneValidation(rowData),
      },
      {
        title: "Password",
        field: "password",
        render: () => <p>--</p>,
        editComponent: (props) => (
          <TextField
            type="password"
            value={props.value}
            autoComplete="off"
            onChange={(e) => props.onChange(e.target.value)}
          />
        ),
      },
      {
        title: "User Type",
        field: "user_type",
        // lookup: { admin: "Admin", superadmin: "Superadmin" },
        validate: (rowData) =>
          rowData.user_type === "" ? "User type is required!" : "",
      },
      {
        title: "User Sub Type",
        field: "user_sub_type",
        //  lookup: { admin: "Admin", superadmin: "Superadmin" },
        validate: (rowData) =>
          rowData.user_sub_type === "" ? "User sub type is required!" : "",
      },
      // {
      //   title: "Permissions",
      //   field: "permission",
      //   render: (rowData) => (
      //     <p>
      //       {rowData.user_type === "admin" ? (
      //         <OverlayTrigger
      //           delay={{ show: 250, hide: 400 }}
      //           placement={"top"}
      //           overlay={
      //             <Tooltip id={`tooltip-qw`}>
      //               {(rowData?.users_permission ?? [])
      //                 .filter((ele) => ele.is_active)
      //                 .map((pr, Idx) => {
      //                   return <div key={Idx}>{pr.permission_module_name}</div>;
      //                 })}
      //             </Tooltip>
      //           }
      //         >
      //           <div className="text-nowrap text-truncate pr-3">
      //             {
      //               rowData?.users_permission?.filter((ele) => ele.is_active)[0]
      //                 ?.permission_module_name
      //             }
      //             ...
      //           </div>
      //         </OverlayTrigger>
      //       ) : (
      //         <OverlayTrigger
      //           delay={{ show: 250, hide: 400 }}
      //           placement={"top"}
      //           overlay={
      //             <Tooltip id={`tooltip-qw`}>
      //               SuperAdmin can see everything
      //             </Tooltip>
      //           }
      //         >
      //           <div className="text-nowrap text-truncate pr-3">--</div>
      //         </OverlayTrigger>
      //       )}
      //     </p>
      //   ),
      //   editComponent: (rowData) =>
      //     !this.state.modelOpenClose && (
      //       <CustomButton
      //         className={"mr-2"}
      //         onClick={() => this.EditRow(rowData)}
      //       >
      //         Set permissons
      //       </CustomButton>
      //     ),
      // },
      {
        title: "Action",
        field: "-",
        render: (rowData) =>
          !modelOpenClose && (
            <div className={"d-flex"}>
              <CustomButton
                className={"mr-2"}
                onClick={() => this.EditRow(rowData)}
              >
                <Edit />
              </CustomButton>
              <CustomButton
                className={"ml-2"}
                onClick={() => this.DeleteRow(rowData)}
              >
                <Delete />
              </CustomButton>
            </div>
          ),
      },
    ];
    console.log("onedit render called:-----");
    if (highsecurity === 1) {
      this.columns.push({
        title: "Last Login",
        field: "last_acessed_at",
        //  lookup: { admin: "Admin", superadmin: "Superadmin" },
        validate: (rowData) => rowData.last_acessed_at,
      });
    }
    return (
      <>
        <Container fluid>
          <Row className="h-100">
            <Col md="12">
              <Card className="h-100">
                <Card.Header>
                  <Card.Title as="h4">Users</Card.Title>
                  <p className="card-category"></p>
                </Card.Header>
                <Card.Body className="pos-rel-overflow-hide uer-list">
                  {/* <h4>User List</h4> */}
                  {loader ? (
                    <Loader />
                  ) : (
                    <StyledDiv style={{ maxWidth: "100%" }}>
                      <MaterialTable
                        title=""
                        components={{
                          Action: (props) => {
                            if (
                              typeof props.action === typeof Function ||
                              props.action.tooltip !== "Add"
                            ) {
                              return <MTableAction {...props} />;
                            } else {
                              return (
                                <div
                                  ref={this.addActionRef}
                                  onClick={props.action.onClick}
                                />
                              );
                            }
                          },
                        }}
                        options={{
                          actionsColumnIndex: -1,
                          addRowPosition: "first",
                          draggable: false,
                        }}
                        columns={this.columns}
                        data={this.state.userList}
                        icons={{
                          Add: (props) => (
                            <Button
                              className="btn-blue-bg"
                              data-mycustomid={"add-icon-handler"}
                            >
                              Add User
                            </Button>
                          ),
                          hidden: true,
                        }}
                        editable={{
                          onRowAddCancelled: (rowData) =>
                            console.log("Row adding cancelled"),
                          onRowUpdateCancelled: (rowData) =>
                            console.log("Row editing cancelled"),
                          onRowAdd: (newData) =>
                            new Promise((resolve, reject) => {
                              setTimeout(() => {
                                this.handleSubmit(newData);
                                resolve();
                              }, 1000);
                            }),
                          onRowUpdate: (newData, oldData) =>
                            new Promise((resolve, reject) => {
                              setTimeout(() => {
                                this.handleUserEdit(newData);
                                resolve();
                              }, 1000);
                            }),
                          onRowDelete: (oldData) =>
                            new Promise((resolve, reject) => {
                              setTimeout(() => {
                                const dataDelete = [...userList];
                                const index = oldData.tableData.id;
                                const userId = oldData.id;
                                dataDelete.splice(index, 1);
                                this.setState([...dataDelete]);
                                this.handleUserDelete(userId);
                                resolve();
                              }, 1000);
                            }),
                        }}
                        actions={[{ hidden: true }]}
                      />
                    </StyledDiv>
                  )}
                  <Col lg="12" className="p-0">
                    {navigationButtons(
                      "/permissions",
                      "/ticket-setup",
                      this.state.property_id,
                      this.addActionRef,
                      "Add User",
                      null,
                      null,
                      null,
                      () => {
                        this.AddRow();
                      }
                    )}
                  </Col>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        {modelOpenClose && (
          <SetPermission
            modelOpenClose={modelOpenClose}
            handleClose={this.handleClose}
            propertyId={this.state.property_id}
            highSecurity={this.props.highSecurity}
            handleUserPermission={this.handleUserPermission}
            userDataToBeEdited={this.state.userDataToBeEdited}
            userTypes={this.props.allUserTypes}
          />
        )}
        {show_alert && (
          <CustomContentAlert
            delay={4000}
            message={api_success_message}
            className="toast-success"
          />
        )}
        {show_error && (
          <CustomContentAlert
            delay={5000}
            message={api_error_message}
            className="toast-error"
          />
        )}
      </>
    );
  }
}

const mapStateToProps = ({ SuperAdminDetails, APIResponseDetails }) => {
  const {
    getAllProperties,
    userList,
    modelOpenClose,
    allUserTypes,
    highSecurity,
  } = SuperAdminDetails;
  const { api_response, api_success_message, api_error_message } =
    APIResponseDetails;
  return {
    userList,
    getAllProperties,
    api_response,
    api_success_message,
    api_error_message,
    modelOpenClose,
    allUserTypes,
    highSecurity,
  };
};

const mapStateToDispatch = {
  addUser: SuperAdminAction.addUser,
  fetchUsers: SuperAdminAction.fetchUsers,
  editUser: SuperAdminAction.editUser,
  deleteUser: SuperAdminAction.deleteUser,
  get_all_properties: SuperAdminAction.get_all_properties,
  setDomainHeader: SuperAdminAction.setDomainHeader,
  fetchAllUserTypes: SuperAdminAction.get_all_user_types,
};

export default connect(mapStateToProps, mapStateToDispatch)(AddUserForm);
const CustomButton = styled(Button)`
  height: 40px;
  width: 40px;
  border-radius: 25px;
  padding: 5px;
`;
const StyledDiv = styled.div`
  max-width: 100%;
  table > thead {
    th:last-child {
      display: none;
    }
  }
  table > tbody {
    td:last-child {
      display: none;
    }
  }
`;
